<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'

const props = withDefaults(defineProps<{
  variant?: 'ear' | 'inline'
  to?: RouteLocationRaw
}>(), {
  variant: 'inline',
})

const router = useRouter()
const feedbackStore = useFeedbackStore()

const shareUrl = computed(() => {
  if (!props.to)
    return window.location.href

  return new URL(router.resolve(props.to).href, window.location.origin).href
})

const { copy, isSupported } = useClipboard({ source: shareUrl, legacy: true })

async function copyLink() {
  if (!isSupported.value) {
    feedbackStore.showToast({
      type: 'error',
      message: 'Не удалось скопировать ссылку',
    })
    return
  }

  try {
    await copy(shareUrl.value)
    feedbackStore.showToast({
      type: 'success',
      message: 'Ссылка скопирована',
    })
  }
  catch (error) {
    console.error('Не удалось скопировать ссылку:', error)
    feedbackStore.showToast({
      type: 'error',
      message: 'Не удалось скопировать ссылку',
    })
  }
}
</script>

<template>
  <VTooltip
    location="bottom"
    text="Копировать ссылку"
  >
    <template #activator="{ props: tooltipProps }">
      <VBtn
        v-bind="tooltipProps"
        icon="ri-link-m"
        :color="variant === 'ear' ? 'primary' : 'secondary'"
        :variant="variant === 'ear' ? undefined : 'text'"
        :class="variant === 'ear' ? 'entity-form-action-btn' : 'flex-shrink-0 hover-primary'"
        aria-label="Копировать ссылку"
        @click="copyLink"
      />
    </template>
  </VTooltip>
</template>
